import { Injectable } from '@angular/core';
import { CommonService } from '../../services';
import { cisname } from '../../services/common/common.model'
import { Observable } from "rxjs/Rx";
import { HttpClient } from '@angular/common/http';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
  queryParams?: { [key: string]: any };
}

export interface Menu {
  state?: string;
  name?: string;
  type: string;
  icon?: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
  companyid?: number
  queryParams?: { [key: string]: any };
}

const MENUITEMS = [

  //new added PMD user for 04-23 2024 GJ as per AD
  {
    state: '/',
    name: 'Dashboard',
    type: 'link',
    icon: 'ion-ios-speedometer'
  },
  // {
  //   type: 'divider'
  // },
  // {
  //   type: 'title',
  //   name: 'Main'
  // },

  {
    state: 'mpmdcmocorner',
    name: 'CMO Corner',
    type: 'link',
    icon: 'ion-ios-medical'
  },
 
  {
    state: 'liveclinic',
    name: 'Supervisory MD Needed In',
    type: 'link',
    icon: 'ion-android-home'
  },

  {
    state: 'statelicensedin',
    name: 'States Licensed In ',
    type: 'link',
    icon: 'ion-ios-world-outline'
  },

  {
    state: 'licensesinprocess',
    name: 'Licenses in Process',
    type: 'link',
    icon: 'ion-ios-clock-outline'
  },

  {
    state: 'supervisoryonfile',
    name: 'Supervisory on File',
    type: 'link',
    icon: 'ion-ios-contact-outline'
  },


  {
    state: 'followupsq',
    name: 'Followup',
    type: 'link',
    icon: 'ion-monitor'
  },
  

  {
    state: 'activerecruitingwithstate',
    name: 'Active Recruiting',
    type: 'link',
    icon: 'ion-ios-world-outline'
  },


  {
    state: 'https://www.dropbox.com/scl/fi/7v6b2ien8hcfae9faook8/States-licensed-KP-Tonia-Natasha-Kirk-06-30-26-MS.pptx?rlkey=x0m9xd3o6u4dy171bwi6m6j5x&st=wuh4fnqh&dl=0',
    name: 'Map',
    type: 'extTabLink',
    icon: 'ion-map'
  },


  {
    state: 'interview',
    name: 'Interview',
    type: 'link',
    icon: 'ion-ios-book-outline'
  },

  {
    state: 'reports',
    name: 'Reports',
    type: 'link',
    icon: 'ion-ios-printer-outline'
  },

  {
    state: '',
    name: 'Internal Resources ',
    type: 'subfolderlink',
    icon: 'ion-document',
    children: [
      {
        state: 'FileServer/Document/Electronic Signature Agreement.pdf',
        name: 'eSignature Agreement'

      },
      {
        state: 'FileServer/Document/ElationEMR ePrescribing Authorization.pdf',
        name: 'eRX Signature Agreement'

      },
      {
        state: 'FileServer/Document/state-law-physician-assistant-scope-practice.pdf',
        name: 'Guidelines on Scope of Care'

      },
      {
        state: 'FileServer/Document/Medical Privileges Request Practitioner Name.pdf',
        name: 'Medical Privileges Request'

      },
      {
        state: 'FileServer/Document/Med-Peds Physician Job Description.pdf',
        name: 'Med-Peds Physician Job Desc'

      },
      {
        state: 'FileServer/Document/Nurse Practitioner Job Description.pdf',
        name: 'Nurse Practitioner Job Desc'

      },
      {
        state: 'https://portal.indianamedicaid.com/hcp/provider/Home/ProviderEnrollment/tabid/477/Default.aspx',
        name: 'OPR Application'

      },
      {
        state: 'FileServer/Document/01 2019-12-10_Provider Expectations.pdf',
        name: 'Provider Expectations'

      },
      {
        state: 'FileServer/Document/03 2019-12-10_Provider Fitness for Proactive MD Rubric.pdf',
        name: 'Provider Fitness Rubric'

      },

      {
        state: 'FileServer/Document/Provider Interview Questions 2017.pdf',
        name: 'Provider Interview Questions'

      },
      {
        state: 'https://www.aama-ntl.org/employers/state-scope-of-practice-laws',
        name: 'Scope of practice by State'

      }

    ]
  },

  // New Child menu added  06-16 2026  GJ as per AD
  {
    state: '',
    name: 'ProactiveMD',
    type: 'subfolderlink',
    icon: 'ion-document',
    children: [
      {
        state: 'cmocorner',
        name: 'PMD CMO Corner',
        type: 'link',
        icon: 'ion-ios-medical'
      },
      {
        state: 'access2md',
        name: 'PMD On Staff',
        type: 'link',
        icon: 'ion-ios-medical'
      },
      {
        state: 'paststaff',
        name: 'PMD Past Staff',
        type: 'link',
        icon: 'ion-ios-medical'
      },
      {
        state: 'cliniclocation',
        name: 'Health Center PMD',
        type: 'link',
        icon: 'ion-android-home',
        queryParams: { ismpmd: false }
      },

    ]

  }

];

//  LIVE MPMD recruits menu is below GJ

const MENUITEMS2 = [
  {
    state: '/',
    name: 'Dashboard',
    type: 'link',
    icon: 'ion-ios-speedometer'
  },

  {
    state: 'mpmdcmocorner',
    name: 'CMO Corner',
    type: 'link',
    icon: 'ion-ios-medical'
  },

  {
    state: 'liveclinic',
    name: 'Supervisory MD Needed In',
    type: 'link',
    icon: 'ion-android-home'
  },

  {
    state: 'statelicensedin',
    name: 'States Licensed In',
    type: 'link',
    icon: 'ion-ios-world-outline'
  },

  {
    state: 'licensesinprocess',
    name: 'Licenses in Process',
    type: 'link',
    icon: 'ion-ios-clock-outline'
  },

  {
    state: 'supervisoryonfile',
    name: 'Supervisory on File',
    type: 'link',
    icon: 'ion-ios-contact-outline'
  },

  {
    state: 'followupsq',
    name: 'Followup',
    type: 'link',
    icon: 'ion-monitor'
  },

  {
    state: 'activerecruitingwithstate',
    name: 'Active Recruiting',
    type: 'link',
    icon: 'ion-ios-world-outline'
  },

  {
    state: 'https://www.dropbox.com/scl/fi/7v6b2ien8hcfae9faook8/States-licensed-KP-Tonia-Natasha-Kirk-06-30-26-MS.pptx?rlkey=x0m9xd3o6u4dy171bwi6m6j5x&st=wuh4fnqh&dl=0',
    name: 'Map',
    type: 'extTabLink',
    icon: 'ion-map'
  },
  {
    state: 'cliniclocation',
    name: 'Health Center MPMD',
    type: 'link',
    icon: 'ion-android-home',
    queryParams: { ismpmd: true }
  },


  {
    state: 'interview',
    name: 'Interview',
    type: 'link',
    icon: 'ion-ios-book-outline'
  },

  {
    state: 'reports',
    name: 'Reports',
    type: 'link',
    icon: 'ion-ios-printer-outline'
  },

  {
    state: '',
    name: 'Internal Resources ',
    type: 'subfolderlink',
    icon: 'ion-document',
    children: [
      {
        state: 'FileServer/Document/Electronic Signature Agreement.pdf',
        name: 'eSignature Agreement'

      },
      {
        state: 'FileServer/Document/ElationEMR ePrescribing Authorization.pdf',
        name: 'eRX Signature Agreement'

      },
      {
        state: 'FileServer/Document/state-law-physician-assistant-scope-practice.pdf',
        name: 'Guidelines on Scope of Care'

      },
      {
        state: 'FileServer/Document/Medical Privileges Request Practitioner Name.pdf',
        name: 'Medical Privileges Request'

      },
      {
        state: 'FileServer/Document/Med-Peds Physician Job Description.pdf',
        name: 'Med-Peds Physician Job Desc'

      },
      {
        state: 'FileServer/Document/Nurse Practitioner Job Description.pdf',
        name: 'Nurse Practitioner Job Desc'

      },
      {
        state: 'https://portal.indianamedicaid.com/hcp/provider/Home/ProviderEnrollment/tabid/477/Default.aspx',
        name: 'OPR Application'

      },
      {
        state: 'FileServer/Document/01 2019-12-10_Provider Expectations.pdf',
        name: 'Provider Expectations'

      },
      {
        state: 'FileServer/Document/03 2019-12-10_Provider Fitness for Proactive MD Rubric.pdf',
        name: 'Provider Fitness Rubric'

      },

      {
        state: 'FileServer/Document/Provider Interview Questions 2017.pdf',
        name: 'Provider Interview Questions'

      },
      {
        state: 'https://www.aama-ntl.org/employers/state-scope-of-practice-laws',
        name: 'Scope of practice by State'

      }

    ]
  },


  {
    state: '',
    name: 'ProactiveMD',
    type: 'subfolderlink',
    icon: 'ion-document',
    children: [
      {
        state: 'cmocorner',
        name: 'PMD CMO Corner',
        type: 'link',
        icon: 'ion-ios-medical'
      },
      {
        state: 'access2md',
        name: 'PMD On Staff',
        type: 'link',
        icon: 'ion-ios-medical'
      },
      {
        state: 'paststaff',
        name: 'PMD Past Staff',
        type: 'link',
        icon: 'ion-ios-medical'
      },
      {
        state: 'cliniclocation',
        name: 'Health Center PMD',
        type: 'link',
        icon: 'ion-android-home',
        queryParams: { ismpmd: false }
      },
      {
        state: 'http://apprecruits.govirtual-now.com/',
        name: 'Clinician Pool',
        type: 'extTabLink',
        icon: 'ion-ios-people'
      },
    ]

  }
];
const MENUITEMS3 = [
  {
    state: '/',
    name: 'Dashboard',
    type: 'link',
    icon: 'ion-ios-speedometer'
  },


];

// Clinician login menu (companyid=1 and sessiontype=2) - added 07-30 2026 GJ
// Interview, Internal Resources and ProactiveMD are hidden, and CMO Corner is renamed to Profile
const MENUITEMS_CLINICIAN = [

  {
    state: '/',
    name: 'Dashboard',
    type: 'link',
    icon: 'ion-ios-speedometer'
  },

  {
    state: 'mpmdcmocorner',
    name: 'Profile',
    type: 'link',
    icon: 'ion-ios-medical'
  },

  {
    state: 'liveclinic',
    name: 'Supervisory MD Needed In',
    type: 'link',
    icon: 'ion-android-home'
  },

  {
    state: 'statelicensedin',
    name: 'States Licensed In ',
    type: 'link',
    icon: 'ion-ios-world-outline'
  },

  {
    state: 'licensesinprocess',
    name: 'Licenses in Process',
    type: 'link',
    icon: 'ion-ios-clock-outline'
  },

  {
    state: 'supervisoryonfile',
    name: 'Supervisory on File',
    type: 'link',
    icon: 'ion-ios-contact-outline'
  },

  {
    state: 'followupsq',
    name: 'Followup',
    type: 'link',
    icon: 'ion-monitor'
  },

  // {
  //   state: 'activerecruitingwithstate',
  //   name: 'Active Recruiting',
  //   type: 'link',
  //   icon: 'ion-ios-world-outline'
  // },

  {
    state: 'https://www.dropbox.com/scl/fi/7v6b2ien8hcfae9faook8/States-licensed-KP-Tonia-Natasha-Kirk-06-30-26-MS.pptx?rlkey=x0m9xd3o6u4dy171bwi6m6j5x&st=wuh4fnqh&dl=0',
    name: 'Map',
    type: 'extTabLink',
    icon: 'ion-map'
  },

  {
    state: 'reports',
    name: 'Reports',
    type: 'link',
    icon: 'ion-ios-printer-outline'
  },

];

@Injectable()
export class MenuService {
  public cisnamevalue: string;
  cisnamelist: cisname[] = [];
  constructor(private http: HttpClient, private commonService: CommonService) {

  }
  companyid = localStorage.getItem('companyid');
  cusertype = localStorage.getItem('sessiontype');
  getAll(): Menu[] {
    if (this.companyid == '1' && this.cusertype == '2') {
      return MENUITEMS_CLINICIAN
    }
    switch (this.companyid) {
      case '1':
        return MENUITEMS
        break
      case '2':
        return MENUITEMS2
        break
      case 'null':
        return MENUITEMS
        break

    }

  }
  getCISnamemenulist() {
    this.commonService.getCISNameAllList().subscribe(success => {
      if (success) {
        this.cisnamelist = this.commonService.cisnamelist;
        this.cisnamevalue = this.commonService.cisnamelist[0].cisName;
        //console.log(this.cisnamevalue);
      }
    })
  }

}

